export default {
    poweredBy: "Poháněno"
}